var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" Desarrollado por "),_c('span',[_c('a',{staticStyle:{"color":"#83111b"},attrs:{"href":"https://www.nebulajuno.com","target":"_blank"},domProps:{"textContent":_vm._s('Nebula Juno')}}),_c('br'),_c('small',[_vm._v(_vm._s(_vm.$version))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }